import axios, { AxiosPromise } from 'axios';
import { IOutlet } from '../../../@types/model/masterData/outlet/outlet';


export default class OutletHttpService {
    public static getOutletData() : AxiosPromise<Array<IOutlet>> {
        return axios.get(`${API_URL}/v1/Outlet/GetAllWeb`);
    }

    public static addOrUpdateOutlet(data : IOutlet) : AxiosPromise<IOutlet> {
        return axios.post(`${API_URL}/v1/Outlet/PostOutlet`, data);
    }

    public static deleteOutlet(outletId : number) : AxiosPromise<IOutlet> {
        return axios.delete(`${API_URL}/v1/Outlet/Delete`, {
            params : { outletId },
        });
    }
}
